const REFERENCE_ASSETS = require('../reference-assets.js');

module.exports = {
    ftm: {
        id: 'ftm',
        type: REFERENCE_ASSETS.FTM,
        symbol: 'FTM',
        decimals: 1e18,
        address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    },
    wftm: {
        id: 'wftm',
        type: REFERENCE_ASSETS.FTM,
        symbol: 'WFTM',
        decimals: 1e18,
        address: '0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83',
        coingeckoId: 'wrapped-fantom',
    },
    dai: {
        id: 'dai',
        type: REFERENCE_ASSETS.USD,
        coingeckoId: 'dai',
        symbol: 'DAI',
        decimals: 1e18,
        address: '0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e',
    },
    usdc: {
        id: 'usdc',
        type: REFERENCE_ASSETS.USD,
        coingeckoId: 'usd-coin',
        symbol: 'USDC',
        decimals: 1e6,
        address: '0x04068da6c83afcfa0e13ba15a6696662335d5b75',
    },
    fusdt: {
        id: 'fusdt',
        type: REFERENCE_ASSETS.USD,
        symbol: 'fUSDT',
        coingeckoId: 'tether',
        decimals: 1e6,
        address: '0x049d68029688eabf473097a2fc38ef61633a3c7a',
    },
    gdai: {
        id: 'gdai',
        type: REFERENCE_ASSETS.USD,
        symbol: 'gDAI',
        decimals: 1e18,
        address: '0x07e6332dd090d287d3489245038daf987955dcfb',
        wrappedCoinType: 'aave',
        coingeckoId: 'geist-dai',
    },
    gusdc: {
        id: 'gusdc',
        type: REFERENCE_ASSETS.USD,
        coingeckoId: 'geist-usdc',
        symbol: 'gUSDC',
        decimals: 1e6,
        address: '0xe578c856933d8e1082740bf7661e379aa2a30b26',
        wrappedCoinType: 'aave',
    },
    gusdt: {
        id: 'gusdt',
        type: REFERENCE_ASSETS.USD,
        symbol: 'gUSDT',
        coingeckoId: 'tether',
        decimals: 1e6,
        address: '0x940f41f0ec9ba1a34cf001cc03347ac092f5f6b5',
        wrappedCoinType: 'aave',
    },
    twocrv: {
        id: 'twocrv',
        type: REFERENCE_ASSETS.USD,
        coingeckoId: 'usd-coin',
        symbol: '2Crv',
        decimals: 1e18,
        address: '0x27e611fd27b276acbd5ffd632e5eaebec9761e40',
        isLpToken: true,
    },
    wbtc: {
        id: 'wbtc',
        coingeckoId: 'wrapped-bitcoin',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'wBTC',
        decimals: 1e8,
        address: '0x321162Cd933E2Be498Cd2267a90534A804051b11',
    },
    renbtc: {
        id: 'renbtc',
        coingeckoId: 'renbtc',
        type: REFERENCE_ASSETS.BTC,
        symbol: 'renBTC',
        decimals: 1e8,
        address: '0xDBf31dF14B66535aF65AaC99C32e9eA844e14501',
    },
    eth: {
        id: 'eth',
        coingeckoId: 'ethereum',
        type: REFERENCE_ASSETS.ETH,
        symbol: 'ETH',
        decimals: 1e18,
        address: '0x74b23882a30290451A17c44f4F05243b6b58C76d',
    },
    cydai: {
        id: 'cydai',
        coingeckoId: 'dai',
        type: REFERENCE_ASSETS.USD,
        symbol: 'cyDAI',
        decimals: 1e8,
        address: '0x04c762a5dF2Fa02FE868F25359E0C259fB811CfE',
        wrappedCoinType: 'iearn-cream',
    },
    cyusdc: {
        id: 'cyusdc',
        coingeckoId: 'usd-coin',
        type: REFERENCE_ASSETS.USD,
        symbol: 'cyUSDC',
        decimals: 1e8,
        address: '0x328A7b4d538A2b3942653a9983fdA3C12c571141',
        wrappedCoinType: 'iearn-cream',
    },
    cyusdt: {
        id: 'cyusdt',
        type: REFERENCE_ASSETS.USD,
        coingeckoId: 'tether',
        symbol: 'cyUSDT',
        decimals: 1e8,
        address: '0x70faC71debfD67394D1278D98A29dea79DC6E57A',
        wrappedCoinType: 'iearn-cream',
    },
};
